<template>
  <div class="mw-split-container">
    <unitDialog @confirm="confirmUnit" ref="unitDialog" :selectUnitId="group.unitId" ></unitDialog>
    <mw-dialog size="large_large"  title="选择用户" ref="userDialog" :footerButton="userFooterButton" :close-on-click-modal="false">
      <loadMan ref="userChoose" :isRadio="true" :defaultParentId="defaultParentId" :listAble="listAble" :RAdminData="oneChooseUsers" ></loadMan>
    </mw-dialog>
    <mw-dialog size="large_large"  title="选择用户" ref="userDialog2" :footerButton="userFooterButton2" :close-on-click-modal="false">
      <loadMan ref="userChoose2" :RAdminData="chooseUsers" :defaultParentId="defaultParentId" :listAble="listAble"></loadMan>
    </mw-dialog>
    <split-pane :defaultSize="378" split="vertical">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button @click="addGroup" size="mini"><i class="fa fa-plus-square"></i>新增</el-button>
            <el-button @click="deleteGroup" size="mini"><i class="fa fa-trash-o"></i>删除</el-button>
            <el-button @click="expand"  v-show="expandFlag==1" size="mini"><i class="fa fa-angle-double-down"></i>展开</el-button>
            <el-button @click="closed"  v-show="expandFlag!=1" size="mini"><i class="fa fa-angle-double-up"></i>折叠</el-button>
          </div>
          <div class="mw-toolbar__body">
            <mw-tree :url="groupTreeUrl" :autoLoad="false" :async="true" :contextMenuItem="contextMenuItem" :multipleLeaf="true"
                     :dragEnable="true" :defaultParams="defaultTreeParams"  :expandedFirst="true" ref="groupTree" @changed="changed"  :selectFirst="true" ></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <div class="mw-toolbar">
            <el-button @click="saveGroup" size="mini"  v-loading.fullscreen.lock="loading"><i class="fa fa-file-text-o"></i> 保存</el-button>
            <!--<el-button type="info" @click="helpnotes" style="float:right;margin-top: 8px;">
              <i class="fa fa-question"></i>帮助
            </el-button>
            -->
          </div>
          <div class="mw-toolbar__body">
            <el-form class="mw-form" label-width="130px" :rules="rules" :model="group" ref="groupForm">
              <el-col :span="24">
                <el-form-item label="单位名称" prop="unitName">
                  <el-input v-model="group.unitName" readonly>
                  </el-input>
                  <el-button @click="showUnitDialog" v-if="isEdit">选择</el-button>
                </el-form-item>
                <el-form-item prop="unitId" v-show="false">
                  <el-input v-model="group.unitId"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="授权用户" prop="name">
                  <el-input v-model="group.name" readonly></el-input>
                  <el-button @click="userChoose"  v-if="!group.id">选择</el-button>
                </el-form-item>
                <el-form-item prop="id" v-show="false">
                  <el-input v-model="group.id"></el-input>
                </el-form-item>
                <el-form-item prop="userId" v-show="false">
                  <el-input v-model="group.userId"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="权限类型" prop="code">
                  <el-select v-model="group.code" placeholder="请选择" :disabled="!isEdit">
                    <el-option
                      v-for="item in authTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="代理用户" prop="agents">
                  <el-input type="textarea" :rows="2" v-model="group.agents" readonly>
                  </el-input>
                  <el-button @click="userChoose2" v-if="isEdit">选择</el-button>
                </el-form-item>
                <el-form-item prop="agentIds" v-show="false">
                  <el-input v-model="group.agentIds"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="isFullAuthSendMsgSelection">
                <el-form-item label="消息提醒代理用户" prop="msgRemindAgents">
                  <el-input type="textarea" :rows="2" v-model="group.msgRemindAgents" readonly>
                  </el-input>
                  <el-button @click="userChoose3" >选择</el-button>
                </el-form-item>
                <el-form-item prop="msgRemindAgents" v-show="false">
                  <el-input v-model="group.msgRemindAgents"></el-input>
                </el-form-item>
              </el-col>

            </el-form>
          </div>
        </div>
      </template>
    </split-pane>
  </div>
</template>
<script>
  import loadMan from "./user/loadManager.vue";
  import unitDialog from "./user/unitDialog";
  import { mapGetters } from 'vuex';
  export default {
    components: {
      loadMan,
      unitDialog
    },
    data() {
      let me = this;
      let defaultParams = {isShowChild:true,type:'full_auth',unitId:""};
      let expUser = me.$store.getters.expUser;
      if(!expUser.developer && !this.isSysAdmin() && me.$store.getters.expUser.unitAdmin){
        let unitObj = me.$store.getters.unitDepartments;
        defaultParams.unitId = me.$store.getters.curSelUnitId || (unitObj && unitObj[0].id) || "";
      }
      let isAuthMsgSelection=window.$Env?(window.$Env.IsFullAuthSendMsgSelection||false):false;
      return {
        expandFlag:1,
        userDialogVisible: false,
        defaultTreeParams:defaultParams,
        groupTreeUrl: this.mwUrl('/api/org/getGroupTreeByType'),
        unitTreeUrl: this.mwUrl('/api/org/getUnitTree'),
        isEdit:true,
        contextMenuItem: [{name: 'add', icon: 'fa fa-plus-square', label: '新增', func: me.addGroup}, {
          name: 'delete',
          label: '删除',
          icon: 'fa fa-trash-o',
          func: me.deleteGroup
        }],
        unitFooterButton: [
          {label: '确定', func: me.selectUnitSure},
          {label: '取消', func: me.selectUnitCancel,type: 'default'}
        ],
        userFooterButton: [
          {label: '确定', func: me.selectUserSure},
          {label: '取消', func: me.cancelSelectUser,type: 'default'}
        ],
        userFooterButton2: [
          {label: '确定', func: me.selectUserSure2},
          {label: '取消', func: me.cancelSelectUser2,type: 'default'}
        ],
        authTypes:[{label:"公司",value:"公司"},{label:"部门",value:"部门"},{label:"领导",value:"领导"}],
        selectUnitId: '',
        curUnitId:'',
        group: {
          id: '',
          code: '',
          name: '',
          unitId: '',
          unitName: '',
          userId:'',
          agents:'',
          agentIds:'',
          agentDeptIds:'',
          type:'full_auth',
          msgRemindAgents:'',
          msgRemindAgentIds:'',
        },
        rules: {
          name: [
            {required: true, message: '请选择授权用户', trigger: 'change'}
          ],
          code: [
            {required: true, message: '请选择权限类型', trigger: 'change'}
          ],
          unitName: [
            {required: true, message: '请选择单位名称', trigger: 'change'}
          ],
          agents:[
            {required: true, message: '请选择代理用户', trigger: 'change'}
          ]
        },
        chooseUsers:[],
        oneChooseUsers:[],
        defaultParentId: '',
        listAble: false,
        loading: false,
        change: false,
        reset: false,
        form1: {},
        isFirstOpen:true,
        isFullAuthSendMsgSelection:isAuthMsgSelection,
      }
    },
    mounted() {
      this.mwRef("groupTree").renderTree();
    },
    methods: {
      //树选择
      changed(data) {
        let me = this;
        if(this.change){
          this.$confirm('文档修改后尚未保存，是否保存?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            me.saveGroup();
          }).catch(() => { me.refresh();});
          me.change =  false;
        }else{
          if (data.id && data.hasChild == 0) {
            me.resetFields();
            me.mwApi.org.getGroup(data.id).then(res => {
              for(let i in res.result){
                me.form1[i] = res.result[i]
              }
              if(res.result.isDeptSave){
                me.isEdit = false;
              }else{
                me.isEdit = true;
              }
              me.mwUtil.applyCover(me.group, res.result);
              if(res.result.msgRemindAgents==undefined ||res.result.msgRemindAgentIds==undefined){
                me.group.msgRemindAgents= me.group.agents;
                me.group.msgRemindAgentIds=me.group.agentIds;
              }
            })
            this.reset = false;
          }
        }
      },
      isSysAdmin(){
        let expUser = this.$store.getters.expUser;
        if(expUser.allIdentityRoleNames && expUser.allIdentityRoleNames.indexOf("系统管理员") !=-1){
          return true;
        }
        return false;
      },
      confirmUnit(){
        var data =this.mwRef('unitDialog').getValue();
        this.group.unitId = data.id;
        this.group.unitName = data.text;
      },
      expand() {
        this.expandFlag = 2;
        this.mwRef('groupTree').openAll();
      },
      closed() {
        this.expandFlag = 1;
        this.mwRef('groupTree').closeAll();
      },
      showUnitDialog() {
        let me = this;
        me.selectUnitId = me.group.unitId;
        this.mwRef('unitDialog').show();
        MW.test(function(){
          if(me.mwRef('unitDialog').mwRef('unitTree'))
            return true;
          return false;
        },function(){
          me.mwRef('unitDialog').mwRef('unitTree').defaultParams.parentId=me.curUnitId;
          me.mwRef('unitDialog').mwRef('unitTree').renderTree();
        },50);
      },
      userChoose() {
        if(this.group.unitId){
          this.mwRef('userDialog').show();
          if(this.group.name && this.group.id){
            this.chooseUsers.push({
              name: this.group.name,
              id: this.group.id
            })
          }else{
            this.oneChooseUsers = [];
          }
          this.defaultParentId =  this.group.unitId;
          let treeObj = this.mwRef('userChoose');
          if(treeObj){
            treeObj.refreshTree(true);
          }
        }else{
          this.mwMsg('请选择单位');
        }
      },
      userChoose2() {
        if(this.group.unitId){
          this.mwRef('userDialog2').show();
          this.chooseUsers = [];
          this.defaultParentId =  this.group.unitId;
          let treeObj = this.mwRef('userChoose2');
          if(treeObj){
            treeObj.refreshTree(true);
          }
          if (this.group.agents) {
            let names = this.group.agents.split(',');
            let ids = this.group.agentIds.split(',');
            let departmentIds = this.group.agentDeptIds.split(",");
            for (let i = 0; i < names.length; i++) {
              this.chooseUsers.push({
                name: names[i],
                departmentId:departmentIds[i],
                id: ids[i]
              })
            }
          }
        }else{
          this.mwMsg('请选择单位');
        }
      },
      userChoose3(){
        let me=this;
        let names = me.group.agents.split(',');
        let ids = me.group.agentIds.split(',');
        let data=[];
        ids.forEach(function (id,index){
          data.push({id:id,text:names[index],label:names[index],children:false});
        })
        var checkNodeIds=[];
        if(me.group.msgRemindAgentIds)
           checkNodeIds=me.group.msgRemindAgentIds.split(",");
        let config={multiple:true,data:data,checkNodeIds:checkNodeIds};
        PF.treeSelect(config, function (objs) {
          let ids=[];
          let names=[];
          if(objs.length>0){
            objs.forEach(function (node) {
              ids.push(node.id);
              names.push(node.text);
            })
            me.group.msgRemindAgents= names.join(",");
            me.group.msgRemindAgentIds=ids.join(",");
          }else{
            me.group.msgRemindAgents="";
            me.group.msgRemindAgentIds="";
          }
        })
      },
      //选择用户
      selectUserSure() {
        this.mwRef('userDialog').hide();
        this.group.name = '';
        this.group.userId = '';
        let data = this.mwRef('userChoose').getValue();
        if(data && data.length > 0){
          let d = data[0];
          this.group.name = d.name;
          this.group.userId = d.id;
        }
      },
      //选择用户
      selectUserSure2() {
        this.mwRef('userDialog2').hide();
        this.group.agents = '';
        this.group.agentIds = '';
        let data = this.mwRef('userChoose2').getValue();
        let userNames = [];
        let userIds = [];
        let agentDeptIds = [];
        data.forEach(d => {
          userNames.push(d.name);
          userIds.push(d.id);
          agentDeptIds.push(d.departmentId);
        });
        this.group.agents = userNames.join();
        this.group.agentIds = userIds.join();
        this.group.agentDeptIds = agentDeptIds.join();
      },
      helpnotes(){
        //PF.showHelp({url:'/helpDoc/platform/role_management.md'})
      },
      resetFields() {
        this.reset = true;
        this.mwRef('groupForm').resetFields();
      },
      cancelSelectUser(){
        this.mwRef('userDialog').hide();
      },
      cancelSelectUser2(){
        this.mwRef('userDialog2').hide();
      },
      addGroup() {
        this.resetFields();
        this.isEdit = true;
        var date = this.mwRef('groupTree').getSelected();
        this.group.unitName = date.unitName?date.unitName:date.name;
        this.group.unitId = date.unitId?date.unitId:date.id;
      },
      saveGroup() {
        let me = this;
        me.mwRef('groupForm').validate((valid => {
          if (valid) {
            $.post("/api/org/saveFullAuthGroup",me.group).then(function(data){
              if(!data.success){
                me.mwMsg(data.msg);
                return;
              }
              me.refresh();
              me.mwMsg('全权代办保存成功');
            });
          }
        }));
      },
      refresh(){
        this.resetFields();
        this.mwRef('groupTree').refresh();
      },
      deleteGroup(data) {
        let me = this;
        if(!data.id){
          if(this.mwRef('groupTree').getSelected()){
            data = this.mwRef('groupTree').getSelected();
          }else{
            me.mwMsg('请选择要删除的节点!');
          }
        }
        let params = {};
        let tipMsg = "";
        if (data.hasChild == 0) {
          if(data.isDeptSave){
            me.mwMsg('商密文书全权代办请在组织成员部门编辑中删除!');
            return;
          }
          params.id = data.id;
          params.name = data.name;
          params.unitName = data.unitName;
          tipMsg = "您确定要删除"+data.name+"的全权代办?";
        }else if(data.level=="2"){
          params.code = data.name;
          params.unitName = data.unitName;
          params.unitId = data.unitId;
          tipMsg = "您确定要删除权限类型"+data.name+"下的所有全权代办?";
        } else if(data.level=="1"){
          params.unitId = data.id;
          params.unitName = data.name;
          tipMsg = "您确定要删除"+data.name+"单位下的所有全权代办?";
        }else{
          me.mwMsg("请选择你要删除的数据");
          return;
        }
        me.mwConfirm(tipMsg).then(() => {
          $.post("/api/org/deleteFullAuthGroup",params).then(function(data){
            if(!data.success){
              me.mwMsg(data.msg);
              return;
            }
            me.refresh();
          });
        }).catch(() => {
        });
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'expUser'
      ]),
    },
    watch:{

    }

  }
</script>
<style scoped>
  .el-tree-node__content .el-checkbox {
    display: none;
  }

  .el-input, .el-textarea {
    width: 60%;
  }

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/fullAuth.vue